/**
 * LokiCopy.js
 * The Loki Copy Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";

export class LokiCopy extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probAddRandom = Game.utils.assertNumber(enemyData.ProbAddRandom, 1);
        const probIllusion = Game.utils.assertNumber(enemyData.ProbIllusion, 1);
        const probDecoy = Game.utils.assertNumber(enemyData.ProbDecoy, 1);

        // Ability choices
        this._abilityChoices.addChoice(EnemyAbilities.eADD_RANDOM, probAddRandom);
        this._abilityChoices.addChoice(EnemyAbilities.eILLUSION, probIllusion);
        this._abilityChoices.addChoice(EnemyAbilities.eDECOY, probDecoy);

        /** @private @type {Number} - Number of bubbles to cast with the Illusion ability */
        this._nbBubblesIllusion = Game.utils.assertNumber(enemyData.IllusionNbr, 1);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eADD_RANDOM:
                let addBubbleDataRandom = {
                    nbBubbles: this._nbBubblesAdd,
                    color: BubbleColor.eRANDOM,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: this._onAbilityCompleted.bind(this)
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleDataRandom);
                break;
            case EnemyAbilities.eILLUSION:
                let addBubbleDataIllusion = {
                    nbBubbles: this._nbBubblesIllusion,
                    color: BubbleColor.eCHAMELEON,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: this._onAbilityCompleted.bind(this)
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleDataIllusion);
                break;
            case EnemyAbilities.eDECOY:
                Game.fire(
                    GameEvents.eGAME_ABILITY_TRANSFORM_TO_SHIELD,
                    this._nbBubblesDecoy,
                    startPos,
                    this._onAbilityCompleted.bind(this)
                );
                break;
            default:
                console.error("[LokiCopy._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }
}
